<app-g-p-balance
  [currency]="currency"
  [balanceInitAmount]="balanceInitAmount"
  [balanceInitDate]="balanceInitDate"
  [balanceTotalAmount]="balanceTotalAmount"
  [balanceTotalDate]="balanceTotalDate"
  [netDeposit]="netDeposit"
  [deposits]="deposits"
  [withdrawals]="withdrawals"
  [totalCurrentCapital]="totalCurrentCapital"
  [balanceSingle]="balanceSingle"
  [balance]="balance"
  [singleChart]="singleChart"
  [hasAllFinancialInstitutions]="hasAllFinancialInstitutions"
  [isLoading]="isLoading"
  [fixedFromDate]="fixedFromDate"
  [fixedToDate]="fixedToDate"
  [showDates]="showDates"
  [variation]="variation"
  [irrAccumulated]="irrAccumulated"
  [irrAccumulatedUSD]="irrAccumulatedUSD"
  [isGeneralBalance]="isGeneralBalance"
  [groupFilterInfo]="groupFilterInfo"
>
</app-g-p-balance>
